/**
 * Wrapper for InvoiceQuickCreateDialog that handles create mutation internally.
 * Used by QuickCreateMenu to create new invoices.
 */

import { useNavigate } from 'react-router-dom';
import { InvoiceQuickCreateDialog } from '../../modules/accounting/components/InvoiceQuickCreateDialog';
import { useCreateInvoice } from '../../modules/accounting/hooks/useInvoices';
import type { InvoiceCreate } from '../../modules/accounting/types';

interface QuickCreateInvoiceFormProps {
  open: boolean;
  onClose: () => void;
}

export function QuickCreateInvoiceForm({ open, onClose }: QuickCreateInvoiceFormProps) {
  const navigate = useNavigate();
  const createInvoice = useCreateInvoice();

  const handleSubmit = async (data: InvoiceCreate) => {
    try {
      const result = await createInvoice.mutateAsync(data);
      onClose();
      navigate(`/accounting/invoices/${result.data.id}`);
    } catch {
      // The global mutation-error handler shows the specific translated toast.
    }
  };

  return (
    <InvoiceQuickCreateDialog
      open={open}
      onClose={onClose}
      onSubmit={handleSubmit}
      isLoading={createInvoice.isPending}
    />
  );
}
